import React, { Component } from 'react';
import { connect } from 'react-redux';


import Loading from "../../components/Loading"
import Popup from "../../components/Popup";
import TemplateDefault from "../Templates/Default";

import API from "../../api";
import { translate } from "../../translate";

import "./style.css";

//import imgBG from "../../../assets/images/bg-full.jpg";

class Lead extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            loading: true,
            errors: [],
            tableCollunsName: [],
            lead: {},
            showPopupPerdido: false,
            showPopupConvertido: false,
            obsLeads: [],
            meusLeads: [],
            isMeuLead: false,
            newObs: { observacao: "" }
        };

        //API.setImageBackground(imgBG);
    }

    //Funcao para criar um fluxo de funcoes composer(fn1,fn2...)(val_to_all_fncs)
    composer = ( ...fns ) => value => fns.length ? fns.reduceRight( ( previousValue, fn ) => fn( previousValue ), value ) : value;


    componentDidMount() {
        this.init();

    }

    init = async () => {
        const { id } = this.props.match.params;
        let self = this;
        await this.getLead( id );

        //init scripts
        window.jQuery( 'input[name="email"]' ).attr( "type", "email" )
        window.jQuery( 'input[name="qtadultos"], input[name="qtdcriancas"]' ).attr( { "type": "number", "min": 0, "max": 500 } )
        window.jQuery( 'input[name="dataultatividade"], input[name="dataproxatividade"], input[name="dataapropriacao"]' ).datepicker( {
            format: 'dd/mm/yyyy',
            autoclose: true,
        } ).on( 'changeDate', function ( e ) {

            self.setState( state => {
                state.lead[e.target.name] = `${e.target.value.split( "/" )[2]}-${e.target.value.split( "/" )[1]}-${e.target.value.split( "/" )[0]} 00:00:00`;

                return state;
            } )

        } );

    }
    //eslint-disable-next-line
    now = () => {
        let now = new Date();
        return `${now.toLocaleDateString().split( "/" )[2]}-${now.toLocaleDateString().split( "/" )[1]}-${now.toLocaleDateString().split( "/" )[0]} ${now.toLocaleTimeString()}`;
        // return new Date().toISOString().match( /(^[0-9]{4}\-[0-9]{2}\-[0-9]{2}|[0-9]{2}:[0-9]{2}:[0-9]{2})/g ).join( " " )
    };

    getLead = ( id ) => {

        return new Promise( async resolve => {
            let meusLeads = await this.getMeusLeads();

            this.setState( {
                errors: [],
                lead: {},
                loading: true,
                idLead: Number( id ),
                isMeuLead: meusLeads.map( l => l.id ).includes( id ),
            } );

            let urlEndpoint = this.state.isMeuLead ? "/meuleadid" : "/lead";

            API.post( urlEndpoint, { id } ).then( r => {
                try {
                    let tableNames = [];
                    let data = Object.values( r.data )[0];

                    if ( data ) {
                        data["motivo"] = null;
                        data["numero_os"] = null;
                        tableNames = Object.keys( data );
                    }

                    this.setState( {
                        lead: data,
                        tableCollunsName: tableNames,
                        loading: false
                    } );

                    this.getObsLead( id, this.props.activeUser.id ).catch( r => {
                        this.props.dispatch( { type: 'NOTIFY', payload: r } );
                    } )

                    resolve( data )
                } catch ( error ) {
                    let errors = [{ type: "alert-danger", msg: "Não foi possivel carregar o lead nesse momento..." }];

                    this.setState( {
                        errors: errors,
                        loading: false
                    } );
                    resolve( [] )
                }

            }, error => {
                let errors = [{ type: "alert-danger", msg: `API error: ${error.status}, Mensagem: ${error.statusText}` }, { type: "alert-danger", msg: "Não foi possivel carregar o lead nesse momento..." }];

                this.setState( {
                    errors: errors,
                    loading: false
                } );

                resolve( [] )
            } );




        } )
    }

    getMeusLeads = () => {
        return new Promise( ( resolve, reject ) => {


            API.post( "/meusleads", { idusuario: this.props.activeUser.id } ).then( r => {
                let data = Object.values( r.data );

                this.setState( state => {

                    state.meusLeads = data;
                    state.loading = false;

                    return state;
                } );

                resolve( data )

            }, error => {

                this.setState( {
                    meusLeads: []
                } );

                resolve( [] )
            } )
        } )

    }

    desapropriar = lead => {
        this.setDesapropria( lead.id ).then( r => {
            this.props.dispatch( { type: 'NOTIFY', payload: r } );
            this.init();
        } )
    }

    apropriar = lead => {
        let { id, dataapropriacao, idusuario, estagio } = lead;

        idusuario = this.props.activeUser.id;
        estagio = "T";
        let now = new Date();
        //eslint-disable-next-line
        dataapropriacao = `${now.toLocaleDateString().split( "/" )[2]}-${now.toLocaleDateString().split( "/" )[1]}-${now.toLocaleDateString().split( "/" )[0]}`;


        this.setApropria( id, dataapropriacao, idusuario, estagio ).then( async ( r ) => {
            let d = [{ title: "", message: r, type: "sucess" }]

            this.props.dispatch( { type: 'NOTIFY', payload: d } );
            this.init();

        } );

    }

    setDesapropria = id => {
        return new Promise( ( resolve, reject ) => {
            this.setState( {
                errors: [],
                loading: true
            } );

            API.post( "/desapropria", { id } ).then( r => {
                let data = Object.values( r.data )[0];

                this.setState( {
                    loading: false
                } );

                let sucess = [{ type: "alert-success", msg: data }];

                resolve( sucess );


            }, error => {
                let errors = [{ type: "alert-danger", msg: "Não foi possivel carregar o lead nesse momento..." }];

                this.setState( {
                    errors: errors,
                    loading: false
                } );

                resolve( errors );
            } )

        } )



    }


    setApropria = ( id, dataapropriacao, idusuario, estagio ) => {

        return new Promise( ( resolve, reject ) => {
            this.setState( {
                errors: [],
                loading: true,
                idLead: id
            } );

            API.put( "/apropria", { id, dataapropriacao, idusuario, estagio } ).then( r => {
                let data = Object.values( r.data )[0];


                this.setState( {
                    loading: false
                } );

                resolve( data )


            }, error => {
                let errors = [{ type: "alert-danger", msg: "Não foi possivel carregar o lead nesse momento..." }];

                this.setState( {
                    errors: errors,
                    loading: false
                } );

                reject( errors )
            } )



        } )
    }


    getObsLead = ( idlead, idusuario ) => {
        return new Promise( ( resolve, reject ) => {
            this.setState( {
                errors: [],
                loading: true
            } );

            API.post( "/obslead", { idlead, idusuario } ).then( r => {
                let data = Object.values( r.data );

                this.setState( {
                    obsLeads: data,
                    loading: false
                } );

                resolve( data )


            }, error => {
                //let errors = [{ type: "alert-danger", msg: "Não foi possivel carregar as observações do lead nesse momento..." }];

                this.setState( {
                    obsLeads: [],
                    //errors: errors,
                    loading: false
                } );

                //reject(errors)
            } )
        } )
    }

    addNewObsTex = txt => {
        this.setState( state => {
            state.newObs = {
                idusuario: this.props.activeUser.id,
                datainteracao: this.now(),
                idlead: this.state.lead.id,
                observacao: txt
            };
            return state;
        } )

    }

    sendNewObs = () => {

        let { idusuario, idlead, datainteracao, observacao } = this.state.newObs;

        return new Promise( ( resolve, reject ) => {
            if ( window.confirm( translate( "Deseja realmente enviar?" ) ) ) {

                this.setState( {
                    errors: [],
                    loading: true
                } );

                API.post( "/addobslead", { idusuario, idlead, datainteracao, observacao } ).then( r => {
                    let data = Object.values( r.data );

                    this.setState( {
                        loading: false,
                    } );

                    this.addNewObsTex( "" )

                    this.getObsLead( this.state.lead.id, this.props.activeUser.id ).catch( r => {
                        this.props.dispatch( { type: 'NOTIFY', payload: r } );
                    } )

                    resolve( data )


                }, error => {
                    let errors = [{ type: "alert-danger", msg: translate( "Não foi possível adicionar..." ) }];

                    this.setState( {
                        errors: errors,
                        loading: false
                    } );

                    this.addNewObsTex( "" )

                    //reject(errors)
                } )


            }
        } )
    }

    fields_excepts = fields => {
        let fields_except = ["id", "idusuario", "numero_os", "motivo"];
        if ( !!!this.state.isMeuLead ) fields_except.push( "estagio", "dataapropriacao", "dataultatividade", "dataproxatividade" ); // Se nao for meu Lead esses campos nao irao aparecer
        return fields.filter( ( f, j ) => !!!fields_except.includes( this.state.tableCollunsName[j] ) );
    }

    fields_is_lock = field_name => {
        let locks = ["id", "id_origem", "idusuario", "dataapropriacao", "dataentrada", "estagio"];
        return locks.includes( field_name );
    }

    dt_format_local = ( dt ) => {
        return dt.map( d => {
            let datainteracao = new Date( d.datainteracao )
            if ( Object.prototype.toString.call( datainteracao ) ) {
                if ( !!!isNaN( datainteracao.getTime() ) ) {
                    d.datainteracao = `${datainteracao.toLocaleDateString()} ${datainteracao.toLocaleTimeString()}`
                }
            }
            return d;

        } )
    }

    salvarLead = lead => {

        if ( window.confirm( "Salvar as alterações?" ) ) {

            this.changeLead( lead ).then( async ( r ) => {
                let d = [{ title: "", message: r, type: "sucess" }]

                this.props.dispatch( { type: 'NOTIFY', payload: d } );
                this.init();

            } );
        }

    }

    leadConvertido = lead => {


        let { id, dataultatividade, idusuario, estagio, numero_os } = lead

        this.setConvertido( id, dataultatividade, idusuario, estagio, numero_os ).then( async ( r ) => {
            let d = [{ title: "", message: r, type: "success" }]

            this.props.dispatch( { type: 'NOTIFY', payload: d } );
            this.init()
        } );


    }

    leadPerdido = lead => {

        let { id, dataultatividade, idusuario, estagio, motivo } = lead

        this.setPerdido( id, dataultatividade, idusuario, estagio, motivo ).then( async ( r ) => {
            let d = [{ title: "", message: r, type: "success" }];

            this.props.dispatch( { type: 'NOTIFY', payload: d } );
            this.init()
        } );

    }

    setConvertido = ( id, dataultatividade, idusuario, estagio, numero_os ) => {

        return new Promise( ( resolve, reject ) => {
            this.setState( {
                errors: [],
                loading: true,
                showPopupConvertido: false
            } );

            window.jQuery( `#myModal2` ).modal( "hide" );

            estagio = "C";// Convertido
            let now = new Date();
            //eslint-disable-next-line
            dataultatividade = `${now.toLocaleDateString().split( "/" )[2]}-${now.toLocaleDateString().split( "/" )[1]}-${now.toLocaleDateString().split( "/" )[0]}`;// now

            API.post( "/converte", { id, dataultatividade, idusuario, estagio, numero_os } ).then( r => {
                let data = Object.values( r.data )[0];

                this.setState( {
                    loading: false
                } );

                resolve( data )


            }, error => {
                let errors = [{ type: "alert-danger", msg: "Não foi possivel converter o lead nesse momento..." }];

                this.setState( {
                    errors: errors,
                    loading: false
                } );

                reject( errors )
            } )



        } )
    }

    setPerdido = ( id, dataultatividade, idusuario, estagio, motivo ) => {

        return new Promise( ( resolve, reject ) => {
            this.setState( {
                errors: [],
                loading: true,
                showPopupPerdido: false
            } );

            window.jQuery( `#myModal1` ).modal( "hide" );

            estagio = "P";// Perdido

            let now = new Date();
            //eslint-disable-next-line
            dataultatividade = `${now.toLocaleDateString().split( "/" )[2]}-${now.toLocaleDateString().split( "/" )[1]}-${now.toLocaleDateString().split( "/" )[0]}`;// now

            API.post( "/perdido", { id, dataultatividade, idusuario, estagio, motivo } ).then( r => {
                let data = Object.values( r.data )[0];

                this.setState( {
                    loading: false,
                    showPopupPerdido: false
                } );
                window.jQuery( `#myModal1` ).modal( "hide" );

                resolve( data )


            }, error => {
                let errors = [{ type: "alert-danger", msg: "Não foi possivel converter o lead nesse momento..." }];

                this.setState( {
                    errors: errors,
                    showPopupPerdido: false,
                    loading: false
                } );

                window.jQuery( `#myModal1` ).modal( "hide" )

                reject( errors )
            } )



        } )
    }

    format_fields_to_view = fields => {

        if ( Array.isArray( fields ) ) {
            return fields.map( f => {
                //format data yyyy-mm-dd to dd/mm/yyyy
                //eslint-disable-next-line
                if ( RegExp( /(^[0-9]{4}\-[0-9]{2}\-[0-9]{2})/g ).test( f ) ) f = new Date( `${f} 00:00:00` ).toLocaleDateString()

                return f;
            } );
        }

        return fields
    }

    changeLeadValues = ( field, val ) => {

        this.setState( state => {

            state.lead[field] = val;

            return state;
        } )

    }

    changeLead = lead => {

        return new Promise( ( resolve, reject ) => {
            this.setState( {
                errors: [],
                loading: true
            } );


            API.post( "/atualizalead", lead ).then( r => {
                let data = Object.values( r.data )[0];

                this.setState( {
                    loading: false
                } );

                resolve( data )


            }, error => {
                let errors = [{ type: "alert-danger", msg: "Não foi possivel atualizar o lead nesse momento..." }];

                this.setState( {
                    errors: errors,
                    loading: false
                } );

                reject( errors )
            } )



        } )

    }

    setMotivo = motivo => {
        this.setState( state => {
            state.lead.motivo = motivo;
            return state;
        } )
    }

    setNumOS = numero_os => {
        this.setState( state => {
            state.lead.numero_os = numero_os;
            return state;
        } )
    }

    render() {
        let { errors } = this.state;
        let fields = this.composer(
            this.fields_excepts,
            this.format_fields_to_view
        )( this.state.lead ? Object.values( this.state.lead ) : [] );

        let fields_collumn_name = this.composer(
            this.fields_excepts
        )( this.state.tableCollunsName );


        let obsLeadsList = this.composer(
            this.dt_format_local
        )( this.state.obsLeads );

        return (
            <TemplateDefault window_close={true}>
                <div id="lead" className="">
                    <h4 style={{ "marginTop": "0" }}>{translate( "Lead" )} - ID: {this.state.idLead} </h4>
                    <hr />

                    {
                        errors.map( ( error, index ) => {
                            return (
                                <div key={index} className={`alert ${error.type || 'alert-danger'} mt-20`}>
                                    <b> <i className="glyphicon glyphicon-alert"></i>  {translate( error.msg )}. </b>
                                </div>
                            );
                        } )
                    }

                    <div className={`body-white ${!!!fields.length || this.state.loading ? "hide" : ""}`}>

                        <div className={`row`}>

                            {
                                fields.map( ( b, j ) => {
                                    let field_name = fields_collumn_name[j];


                                    return (

                                        <div className={`col-md-4 col-xs-6 `} key={j} >
                                            <div className="form-group">
                                                <label className="fieldsLabel" htmlFor={`id-${j}`}>{translate( field_name )}:</label>
                                                <input onChange={e => this.changeLeadValues( field_name, e.target.value )} disabled={!this.state.isMeuLead || this.fields_is_lock( field_name )} type="text" name={field_name} className="form-control" id={`id-${j}`} defaultValue={translate( b )} />
                                            </div>
                                        </div>
                                    )
                                } )
                            }
                            <div className={`col-md-8 col-xs-12 text-right ${!!!this.state.isMeuLead ? "hide" : ""}`}>
                                <button onClick={e => this.salvarLead( this.state.lead )} disabled={!this.state.isMeuLead} className={`btn btn-success mt-20`}><i className="glyphicon glyphicon-floppy-disk"></i>  {translate( "Salvar alterações" )}</button>
                            </div>

                        </div>


                        <div className="row">
                            <div className="col-sm-12">
                                {
                                    this.state.errors.map( ( error, index ) => {
                                        return (
                                            <div key={index} className={`alert ${error.type || 'alert-danger'} mt-20`}>
                                                <b> <i className="glyphicon glyphicon-alert"></i>  {translate( error.msg )} </b>
                                            </div>
                                        );
                                    } )
                                }

                            </div>
                        </div>



                        <div className={`row ${!!!this.state.lead.id || !!!this.state.isMeuLead ? "hide" : ""}`}>
                            <div className="col-sm-12"><hr />
                                <h4><b>{translate( "Observações" )}:</b></h4>

                                <ul className="list-group">
                                    {
                                        obsLeadsList.map( ( o, k ) => (
                                            <li key={o.id} className="list-group-item">
                                                <b className="label label-primary">{o.datainteracao}</b> <span className="linha-mobile"></span> {!!!o.nameUser ? "" : ( <span className="criado"> {translate( "Criado por" )}: {o.nameUser}</span> )} - {translate( o.observacao )} </li>
                                        ) )
                                    }
                                </ul>

                                <div className="input-group">
                                    <input disabled={!!!this.state.isMeuLead} value={this.state.newObs.observacao || ""} onChange={e => this.addNewObsTex( e.target.value )} type="text" className="form-control" placeholder={translate( "Adicionar observação" )} />
                                    <div className="input-group-btn">
                                        <button disabled={!!!this.state.newObs.observacao || ( !!!this.state.newObs.observacao && !!!this.state.isMeuLead )} className="btn btn-primary" type="button" onClick={e => this.sendNewObs()}>
                                            <i className="glyphicon glyphicon-plus	"></i>  {translate( "Observação" )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    {
                        !!!this.state.loading ? "" : (
                            <div className="body-white mt-20 mb-20">
                                <div className="col-sm 12 text-center">
                                    <Loading /> <span style={{ "fontSize": "20px", "margin": "20px" }}> {translate( "Carregando..." )}</span>
                                </div>
                            </div>

                        )
                    }
                    <hr />
                    <div className="row">
                        <div className={`col-sm-3 col-xs-12  mb-20`}>
                            <button onClick={e => window.close()} className="btn btn-mobile btn-link" style={{ color: "#fff" }}><span className="glyphicon glyphicon-arrow-left"></span> Voltar</button>
                        </div>

                        {
                            this.state.isMeuLead ? (
                                ""
                            ) : (
                                    <div className={`col-sm-3 col-xs-6 mb-20 ${!!this.state.loading || !!!this.state.lead.id ? "hide" : ""} ${!!!this.state.isMeuLead ? "pull-right" : ""}`}>
                                        <button onClick={e => this.apropriar( this.state.lead )} className="btn btn-mobile btn-block btn-primary"> {translate( "Apropriar do Lead" )} </button>
                                    </div>
                                )
                        }

                        <div className={`col-sm-3 col-xs-6 mb-20 pull-right ${!!!this.state.isMeuLead || this.state.loading ? "hide" : ""}`}>
                            <button onClick={e => { window.jQuery( `#myModal2` ).modal( { backdrop: "static" } ) }} disabled={!!!this.state.isMeuLead || this.state.lead.estagio === "C" || this.state.lead.estagio === "P"} className="btn btn-mobile btn-block btn-success"> {translate( "Converter Lead" )} </button>
                        </div>
                        <div className={`col-sm-3 col-xs-6 mb-20 pull-right ${!!!this.state.isMeuLead || this.state.loading ? "hide" : ""}`}>
                            <button onClick={e => { window.jQuery( `#myModal1` ).modal( { backdrop: "static" } ) }} disabled={!!!this.state.isMeuLead || this.state.lead.estagio === "P" || this.state.lead.estagio === "C"} className="btn btn-mobile btn-block btn-danger"> {translate( "Lead não foi convertido" )} </button>
                        </div>

 

                    </div>

                    <Popup show={this.state.showPopupPerdido}
                        id="myModal1"
                        title={"Confirma que esse Lead foi perdido?"}
                        footer={
                            <>
                                <button type="button" className="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
                                <button onClick={e => this.leadPerdido( this.state.lead )} disabled={!!!this.state.lead.motivo} type="button" className="btn btn-success" > <i className="glyphicon glyphicon-floppy-disk"></i> Confirmar</button>
                            </>
                        }
                    >
                        <div className="form-horizontal">
                            <div className={`form-group has-feedback ${!!this.state.lead.motivo ? "has-success" : "has-error"}`}>
                                <label className="col-sm-12" htmlFor="inputSuccess">{translate( "Qual o motivo da perca desse Lead?" )}</label>
                                <div className="col-sm-12">
                                    <select defaultValue="" name="idMotivo" className={`form-control`} onChange={e => this.setMotivo( e.target.value )} >
                                        <option value="">{translate( "Selecione" )}</option>
                                        <option value={translate( "Cliente desistiu da viagem" )}>{translate( "Cliente desistiu da viagem" )}</option>
                                        <option value={translate( "Nosso preço estava mais alto" )}>{translate( "Nosso preço estava mais alto" )}</option>
                                        <option value={translate( "Demoramos para responder" )}>{translate( "Demoramos para responder" )}</option>
                                    </select>
                                </div>
                            </div>
                            <small className={`text-danger ${!!this.state.lead.motivo ? "hide" : ""}`}><i className="glyphicon glyphicon-alert"></i> {translate( "campo obrigatório" )}</small>

                        </div>


                    </Popup>

                    <Popup show={this.state.showPopupConvertido}
                        id="myModal2"
                        title={"Confirma que esse Lead foi convertido?"}
                        footer={
                            <>
                                <button type="button" className="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
                                <button onClick={e => this.leadConvertido( this.state.lead )} disabled={!!!this.state.lead.numero_os} type="button" className="btn btn-success" > <i className="glyphicon glyphicon-floppy-disk"></i> Confirmar</button>
                            </>
                        }
                    >
                        <div className="form-horizontal">
                            <div className={`form-group has-feedback ${!!this.state.lead.numero_os ? "has-success" : "has-error"}`}>
                                <label className="col-sm-12" htmlFor="inputSuccess">{translate( "Qual o número da OS?" )}</label>
                                <div className="col-sm-12">
                                    <input defaultValue="" placeholder="Ex: 1234" type="text" className="form-control" onChange={e => this.setNumOS( e.target.value )} />

                                </div>
                            </div>
                            <small className={`text-danger ${!!this.state.lead.numero_os ? "hide" : ""}`}><i className="glyphicon glyphicon-alert"></i> {translate( "campo obrigatório" )}</small>

                        </div>


                    </Popup>


                </div>
            </TemplateDefault >

        )
    }
}

function matchDispatchToProps( dispatch ) {
    return {
        dispatch,
        //...bindActionCreators({selectUser: selectUser}, dispatch)
    };
}

// "state" is set in reducers/index.js
function mapStateToProps( state ) {
    return {
        activeUser: state.activeUser
    };
}

export default connect( mapStateToProps, matchDispatchToProps )( Lead );